"use client";

import React, { useEffect, useState } from "react";
import { CheckboxGroup, Label } from "react-aria-components";
import { Checkbox, Text } from "ui-components";

export interface IUserPronounsProps {
  label?: string;
  isRequired?: boolean;
  selectPronoun?: string;
  onPronounChange?: (selectPronoun: string) => void;
  errorMessage?: string;
  className?: string;
}

export function UserPronouns({
  label,
  isRequired,
  selectPronoun = "",
  onPronounChange,
  errorMessage,
  className = "gap-4",
}: IUserPronounsProps): JSX.Element {
  const [selected, setSelected] = useState<string[]>([selectPronoun]);

  useEffect(() => {
    setSelected([selectPronoun]);
  }, [selectPronoun]);

  function handleSelectPronoun(value: string[]): void {
    if (value.length > 0) {
      const newValue = value[value.length - 1];
      if (newValue) {
        setSelected([newValue]);
        onPronounChange?.(newValue);
      }
    }
  }
  return (
    <CheckboxGroup
      defaultValue={[selectPronoun]}
      className={`flex flex-col ${className}`}
      value={selected}
      onChange={(value) => handleSelectPronoun(value)}
    >
      <Label>
        <Text variant="small" align="left">
          {label}
          {isRequired && (
            <Text
              variant="small"
              intent="secondary"
              className="ml-1"
              align="left"
            >
              (required)
            </Text>
          )}
        </Text>
      </Label>
      <div className="flex flex-row flex-wrap gap-4">
        <Checkbox value="She/Her" label="She/ Her" />
        <Checkbox value="He/Him" label="He/ Him" />
        <Checkbox value="They/Them" label="They/ Them" />
        <Checkbox value="Other" label="Other" />
        <Checkbox value="None" label="Prefer not to say" />
      </div>
      <Text variant="small" intent="danger">
        {errorMessage}
      </Text>
    </CheckboxGroup>
  );
}
